import { FieldError } from 'react-hook-form';
import { cn } from '@/utils/tailwind-merge';
import TextSmall from './TextSmall';

export default function ErrorText({
    error,
    className,
}: {
    error: string | FieldError;
    className?: string;
}) {
    return (
        <TextSmall className={cn('font-trade-gothic text-red line-clamp-1', className)}>
            {typeof error === 'string' ? error : `${error.message}`}
        </TextSmall>
    );
}
